// extracted by mini-css-extract-plugin
export default {"wallet":"SubscriptionSummary_wallet__kZlsk","wallet_ballance":"SubscriptionSummary_wallet_ballance__4tcWc"};